import { FunctionComponent } from 'react';
import FormattedMoney from '@app/shop/components/FormattedMoney';
import { PricingPageShopProduct_magento2_products_items_Magento2_BundleProduct_priceRange as PriceRange } from '../../hook/__generated__/PricingPageShopProduct';

import { OldPrice, CurrentPrice } from './styles';

const PriceComponent: FunctionComponent<{ price?: PriceRange | null }> = ({
  price,
}) => {
  const { regularPrice, finalPrice, discount } = price?.minimumPrice ?? {};

  if (discount?.amountOff) {
    return (
      <>
        <CurrentPrice mb={3} data-testid="product-discount-price">
          <FormattedMoney {...finalPrice} />
        </CurrentPrice>
        <OldPrice data-testid="product-old-price">
          <FormattedMoney {...regularPrice} />
        </OldPrice>
      </>
    );
  }

  return (
    <CurrentPrice data-testid="product-price">
      <FormattedMoney {...finalPrice} />
    </CurrentPrice>
  );
};

export default PriceComponent;
